// About section — original legacy copy (verbatim) + 3-image preview that
// opens the lightbox at the clicked slide.
import { indexTimeValues } from "../../lib/index-time";

interface AboutProps {
  readonly onOpenImage: (index: number) => void;
}

export function About({ onOpenImage }: AboutProps) {
  const { diffInYears } = indexTimeValues(Date.now());

  return (
    <section className="wv-h2-section wv-h2-section--light" id="about">
      <div className="wv-h2-wrap">
        <h2>
          <span className="thin">关于</span> 服务器
        </h2>
        <div className="wv-h2-section-rule"></div>
        <div className="wv-h2-split">
          <div>
            <p>
              随便MC~是资格最老的我的世界公益服。自2011年以来，一直坚持为广大Minecraft爱好者提供稳定的免费我的世界mc服务器游戏平台，
              同时制作大量的原创Minecraft游戏内容。{diffInYears}年来已吸引多位MC大神留驻并培养出大量牛人。
            </p>
            <p>
              同时这里还有一支认真专业的管理团队快速解决玩家各种需求（以及卖萌）。如果你厌倦了熊孩子，
              想要一个和谐、稳定、友好的Minecraft游戏环境，或者想探索你未曾体验过的丰富多彩的游戏乐趣，
              或是想要施展你的才华，创建一个你梦想中的世界，亦或是想在闲暇之余享受日常的安逸，欢迎加入我们随便MC~大家庭!
            </p>
          </div>
          <div className="wv-h2-mini-gallery">
            {[1, 2, 3].map((n) => (
              <button key={n} onClick={() => onOpenImage(n - 1)} aria-label={`查看第 ${n} 张截图`}>
                <img src={`/static/images/index/slides/thumb/${n}.jpg`} alt="随便MC 截图" loading="lazy" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
